import React from "react";
import styled from "styled-components";

const Pattern = () => {
  return (
    <StyledWrapper>
      <div className="bg">
        <div className="container">
          <div className="fractal">
            <div className="cell">
              <div className="nested-grid">
                <div className="mini-cell" />
                <div className="mini-cell" />
                <div className="mini-cell" />
                <div className="mini-cell" />
              </div>
            </div>
            <div className="cell">
              <div className="nested-grid">
                <div className="mini-cell" />
                <div className="mini-cell" />
                <div className="mini-cell" />
                <div className="mini-cell" />
              </div>
            </div>
            <div className="cell">
              <div className="nested-grid">
                <div className="mini-cell" />
                <div className="mini-cell" />
                <div className="mini-cell" />
                <div className="mini-cell" />
              </div>
            </div>
            <div className="cell">
              <div className="nested-grid">
                <div className="mini-cell" />
                <div className="mini-cell" />
                <div className="mini-cell" />
                <div className="mini-cell" />
              </div>
            </div>
            <div className="cell">
              <div className="nested-grid">
                <div className="mini-cell" />
                <div className="mini-cell" />
                <div className="mini-cell" />
                <div className="mini-cell" />
              </div>
            </div>
            <div className="cell">
              <div className="nested-grid">
                <div className="mini-cell" />
                <div className="mini-cell" />
                <div className="mini-cell" />
                <div className="mini-cell" />
              </div>
            </div>
            <div className="cell">
              <div className="nested-grid">
                <div className="mini-cell" />
                <div className="mini-cell" />
                <div className="mini-cell" />
                <div className="mini-cell" />
              </div>
            </div>
            <div className="cell">
              <div className="nested-grid">
                <div className="mini-cell" />
                <div className="mini-cell" />
                <div className="mini-cell" />
                <div className="mini-cell" />
              </div>
            </div>
            <div className="cell">
              <div className="nested-grid">
                <div className="mini-cell" />
                <div className="mini-cell" />
                <div className="mini-cell" />
                <div className="mini-cell" />
              </div>
            </div>
            <div className="cell">
              <div className="nested-grid">
                <div className="mini-cell" />
                <div className="mini-cell" />
                <div className="mini-cell" />
                <div className="mini-cell" />
              </div>
            </div>
            <div className="cell">
              <div className="nested-grid">
                <div className="mini-cell" />
                <div className="mini-cell" />
                <div className="mini-cell" />
                <div className="mini-cell" />
              </div>
            </div>
            <div className="cell">
              <div className="nested-grid">
                <div className="mini-cell" />
                <div className="mini-cell" />
                <div className="mini-cell" />
                <div className="mini-cell" />
              </div>
            </div>
            <div className="cell">
              <div className="nested-grid">
                <div className="mini-cell" />
                <div className="mini-cell" />
                <div className="mini-cell" />
                <div className="mini-cell" />
              </div>
            </div>
          </div>

          <div className="corner corner-tl" />
          <div className="corner corner-tr" />
          <div className="corner corner-br" />
          <div className="corner corner-bl" />
        </div>
      </div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  overflow: hidden;
  rotate: 180deg;
  .bg {
    background: linear-gradient(135deg, #0f0c29, #302b63, #24243e);
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  }

  .container {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .fractal {
    position: absolute;
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: repeat(9, 1fr);
    grid-template-rows: repeat(8, 1fr);
    gap: 0.5vmin;
    transform: rotate(0deg);
    transition: transform 1s ease;
  }

  .cell {
    position: relative;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 3px;
    overflow: hidden;
    transition: all 0.4s ease;
  }

  .cell::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background: radial-gradient(
      circle at center,
      transparent 40%,
      currentColor 100%
    );
    opacity: 0.3;
  }

  .cell:nth-child(4n + 1) {
    background: linear-gradient(
      135deg,
      rgba(106, 17, 203, 0.3),
      rgba(37, 117, 252, 0.2)
    );
    color: #6a11cb;
    animation: pulse1 6s infinite alternate;
  }

  .cell:nth-child(4n + 2) {
    background: linear-gradient(
      135deg,
      rgba(255, 100, 100, 0.3),
      rgba(255, 200, 100, 0.2)
    );
    color: #ff6464;
    animation: pulse2 7s infinite alternate;
  }

  .cell:nth-child(4n + 3) {
    background: linear-gradient(
      135deg,
      rgba(100, 255, 218, 0.3),
      rgba(100, 220, 255, 0.2)
    );
    color: #64ffda;
    animation: pulse3 5s infinite alternate;
  }

  .cell:nth-child(4n + 4) {
    background: linear-gradient(
      135deg,
      rgba(255, 100, 220, 0.3),
      rgba(200, 100, 255, 0.2)
    );
    color: #ff64dc;
    animation: pulse4 8s infinite alternate;
  }

  /* Nested grid inside each cell */
  .nested-grid {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    gap: 1px;
  }

  .mini-cell {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 1px;
  }

  /* Central focus element */
  .center-element {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 30%;
    height: 30%;
    background: linear-gradient(135deg, #6a11cb, #2575fc);
    border-radius: 50%;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 0 40px rgba(106, 17, 203, 0.7),
      inset 0 0 30px rgba(255, 255, 255, 0.3);
    animation: rotate 20s linear infinite;
  }

  .center-element::before {
    content: "";
    position: absolute;
    width: 80%;
    height: 80%;
    border: 3px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    animation: rotate-reverse 15s linear infinite;
  }

  .center-element::after {
    content: "";
    position: absolute;
    width: 50%;
    height: 50%;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    box-shadow: 0 0 20px rgba(255, 255, 255, 0.2);
  }

  /* Animation definitions */
  @keyframes pulse1 {
    0% {
      opacity: 0.6;
      transform: scale(1);
    }
    100% {
      opacity: 1;
      transform: scale(1.05);
    }
  }

  @keyframes pulse2 {
    0% {
      opacity: 0.6;
      transform: scale(1) rotate(0deg);
    }
    100% {
      opacity: 1;
      transform: scale(1.03) rotate(5deg);
    }
  }

  @keyframes pulse3 {
    0% {
      opacity: 0.6;
      transform: scale(1);
    }
    100% {
      opacity: 1;
      transform: scale(0.97);
    }
  }

  @keyframes pulse4 {
    0% {
      opacity: 0.6;
      transform: scale(1) rotate(0deg);
    }
    100% {
      opacity: 1;
      transform: scale(1.02) rotate(-3deg);
    }
  }

  @keyframes rotate {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }

  @keyframes rotate-reverse {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(-360deg);
    }
  }

  /* Title styling */
  .title {
    position: absolute;
    top: 20px;
    left: 0;
    width: 100%;
    text-align: center;
    color: white;
    font-size: 2.5rem;
    text-transform: uppercase;
    letter-spacing: 3px;
    text-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
    z-index: 100;
    opacity: 0.9;
  }

  .subtitle {
    position: absolute;
    bottom: 20px;
    left: 0;
    width: 100%;
    text-align: center;
    color: rgba(255, 255, 255, 0.7);
    font-size: 1rem;
    letter-spacing: 2px;
  }

  /* Corner elements */
  .corner {
    position: absolute;
    width: 30px;
    height: 30px;
    z-index: 20;
  }

  .corner-tl {
    top: 20px;
    left: 20px;
    border-top: 3px solid rgb(255, 255, 255);
    border-left: 3px solid rgb(255, 255, 255);
  }

  .corner-tr {
    top: 20px;
    right: 20px;
    border-top: 3px solid white;

    border-right: 3px solid white;
  }

  .corner-br {
    bottom: 20px;
    right: 20px;
    border-bottom: 3px solid white;
    border-right: 3px solid white;
  }

  .corner-bl {
    bottom: 20px;
    left: 20px;
    border-bottom: 3px solid white;
    border-left: 3px solid white;
  }

  /* Responsive adjustments */
  @media (max-width: 768px) {
    .title {
      font-size: 1.8rem;
    }

    .subtitle {
      font-size: 0.8rem;
    }
  }
`;

export default Pattern;
